import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {premiumFeatureModal_template} from "../components/templates/premiumFeatureModal_template";
import {vnApp_sentinelbi} from "../components/vnApp_sentinelbi";

export class sentinelModule extends vnModule_knockoutJS {

    //
    // Modal to show premium feature upgrade
    public premiumFeatureModal: premiumFeatureModal_template;

    protected getModuleName(): string{

        return 'sentinelModule';
    }

    buildContent() : Array<Element>{

        let vnApp : vnApp_sentinelbi = <vnApp_sentinelbi>this.getVnAppZone().app;
        let isOwner = vnApp.isOfRole(vnApp_sentinelbi.ROLE_OWNER);

        // Create the logo and the title
        this.premiumFeatureModal = new premiumFeatureModal_template('app_premiumFeatureModal', this.viewModel, this);
        this.premiumFeatureModal.setIsOwner(isOwner);

       return [this.premiumFeatureModal.build()];
    }

    public showPremiumModal(feature: string){
        
        this.premiumFeatureModal.setFeature(feature);
        this.premiumFeatureModal.show();
    }
}


// WEBPACK FOOTER //
// ./js/modules/sentinelModule.ts